import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerVisibilityService } from 'ng-http-loader';

@Component({
  selector: 'app-route-validation',
  templateUrl: './route-validation.component.html',
  styleUrls: ['./route-validation.component.scss']
})
export class RouteValidationComponent implements OnInit {

  defaultImage = '../../../../assets/icons/Loading_icon.gif';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private route: Router,
    private dialogRef: MatDialogRef<RouteValidationComponent>,
    private spinner: SpinnerVisibilityService
  ) { }

  ngOnInit(): void {
  }

  okBtnClick(){
    this.spinner.show();
    this.route.navigateByUrl('/').then(() => {
      // window.location.href = "/"
      this.spinner.hide();

    });
  }

}
